module.exports = __webpack_public_path__ + "media/img/frontend_application/nav-logo-white-christmas-df96d06305fa2d8e6d17e8452fdd08d4.png";